import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ShowFieldHistoryPageRoutingModule } from './show-field-history-routing.module';

import { ShowFieldHistoryPage } from './show-field-history.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ShowFieldHistoryPageRoutingModule
  ],
  declarations: [ShowFieldHistoryPage]
})
export class ShowFieldHistoryPageModule {}
